


































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { EventBus } from "@/main";
import {
  LivingAppsReportRecord,
  LivingAppsReportControl,
  LivingAppsLookupItem,
  LivingAppsFileControl,
  LivingAppsGeo,
  LivingAppsRecordValue
} from "@/types";
import store, { StoreReports } from "@/store";
import { Url } from "url";

@Component
export default class ReportDetailForm extends Vue {
  [index: string]: any;

  @Prop() public report?: LivingAppsReportRecord;
  @Prop() public controls?: LivingAppsReportControl | null;

  public formWer2: string = "";
  public formWas2: string = "";
  public formNotiz: string = "";
  public formBildPreview: string = "";
  public formBild: File | LivingAppsFileControl | null = null;
  public formStandort: LivingAppsGeo | null = null;
  public formBewertung: LivingAppsLookupItem[] | null = null;
  public formStatus: LivingAppsLookupItem[] | null = null;
  public formAktion: string = "";
  public formDurchWen2: LivingAppsLookupItem[] | null = null;

  public isDirty: boolean = false;

  public mounted() {
    this.formWer2 = this.getFieldValue("wer2");
    this.formWas2 = this.getFieldValue("was2");
    this.formNotiz = this.getFieldValue("notiz");
    this.formBild = this.getFieldValue("bild");
    this.formStandort = this.getFieldValue("standort");
    this.formBewertung = this.getFieldValue("bewertung");
    this.formStatus = this.getFieldValue("status");
    this.formAktion = this.getFieldValue("aktion");
    this.formDurchWen2 = this.getFieldValue("durch_wen2");
  }

  public get wer2(): string {
    return this.formWer2;
  }

  public set wer2(value: string) {
    this.formWer2 = value;
    this.isDirty = true;
  }

  public get was2(): string {
    return this.formWas2;
  }

  public set was2(value: string) {
    this.formWas2 = value;
    this.isDirty = true;
  }

  public get notiz(): string {
    return this.formNotiz;
  }

  public set notiz(value: string) {
    this.formNotiz = value;
    this.isDirty = true;
  }

  public get bild(): File | LivingAppsFileControl | null {
    return this.formBild;
  }

  public set bild(value: File | LivingAppsFileControl | null) {
    this.formBild = value;
    this.isDirty = true;
  }

  public get standort(): string {
    if (this.formStandort) {
      return this.formStandort.info;
    }
    return "";
  }

  public set standort(value: string) {
    if (this.formStandort) {
      this.formStandort.info = value;
      this.isDirty = true;
    }
  }

  public get bewertung(): LivingAppsLookupItem[] | null {
    if (this.formBewertung) {
      return this.formBewertung;
    }
    return [];
  }

  public set bewertung(value: LivingAppsLookupItem[] | null) {
    this.formBewertung = value;
    this.isDirty = true;
  }

  public get status(): LivingAppsLookupItem[] | null {
    if (this.formStatus) {
      return this.formStatus;
    }
    return [];
  }

  public set status(value: LivingAppsLookupItem[] | null) {
    this.formStatus = value;
    this.isDirty = true;
  }

  public get aktion(): string {
    return this.formAktion;
  }

  public set aktion(value: string) {
    this.formAktion = value;
    this.isDirty = true;
  }

  public get durchWen2(): LivingAppsLookupItem[] | null {
    if (this.formDurchWen2) {
      return this.formDurchWen2;
    }
    return null;
  }

  public set durchWen2(value: LivingAppsLookupItem[] | null) {
    this.formDurchWen2 = value;
    this.isDirty = true;
  }

  public getControl(name: string): any | null {
    if (this.controls && name in this.controls) {
      return this.controls[name].control;
    }
    return null;
  }

  public deleteFile(name: string) {
    this[name] = null;
    this.isDirty = true;
  }

  public updatePreview(fileObj: File | LivingAppsFileControl | null) {
    if (fileObj) {
      if (fileObj instanceof File) {
        const url = URL.createObjectURL(fileObj);
        this.formBildPreview = url;
      } else {
        this.formBildPreview = "https://ci04.ci.xist4c.de" + fileObj.url;
      }
    }
  }

  public getLookupItemForFieldWithKey(
    name: string,
    e: any
  ): LivingAppsLookupItem[] | null {
    const control = this.getControl(name);
    const lupItems: LivingAppsLookupItem[] = [];
    let lupItem: LivingAppsLookupItem;
    if (e) {
      for (lupItem of control.lookupdata) {
        if (lupItem.key === e.target.value) {
          lupItems.push(lupItem);
        }
      }
      return lupItems;
    }
    return null;
  }

  public getFieldValue(name: string): any {
    const control = this.getControl(name);
    if (this.report && control) {
      const rep = this.report[name];
      if (rep) {
        return rep.value;
      }
    }
    return null;
  }

  public isSelected(key: string, name: string): boolean {
    const currLupItems = this[name];
    if (currLupItems && currLupItems.length) {
      for (const currLupItem of currLupItems) {
        if (currLupItem.key === key) {
          return true;
        }
      }
    }
    return false;
  }

  // public cancel() {
  //   this.$emit("cancel");
  // }

  public laRecordWrapper(
    value:
      | string
      | LivingAppsGeo
      | LivingAppsFileControl
      | File
      | LivingAppsLookupItem[]
      | null
  ): LivingAppsRecordValue | null {
    if (value) {
      return { value };
    }
    return null;
  }

  public save() {
    const data: LivingAppsReportRecord = {};
    data.wer2 = this.laRecordWrapper(this.formWer2);
    data.was2 = this.laRecordWrapper(this.formWas2);
    data.notiz = this.laRecordWrapper(this.formNotiz);
    data.bild = this.laRecordWrapper(this.formBild);
    data.standort = this.laRecordWrapper(this.formStandort);
    data.bewertung = this.laRecordWrapper(this.formBewertung);
    data.status = this.laRecordWrapper(this.formStatus);
    data.aktion = this.laRecordWrapper(this.formAktion);
    data.durch_wen2 = this.laRecordWrapper(this.formDurchWen2);
    if (this.report) {
      data.id = this.report.id;
      store.dispatch("updateRecordData", {
        data,
        app: this,
        eventBus: EventBus
      });
    } else {
      store.dispatch("createRecordData", {
        data,
        app: this,
        eventBus: EventBus
      });
    }
  }

  @Watch("bild")
  protected onImageChange(
    value: File | LivingAppsFileControl | null,
    oldValue: File | LivingAppsFileControl | null
  ) {
    this.updatePreview(value);
  }
}
